import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActionI, KeyValue } from '../../models/common';

@Component({
  selector: 'anterasoftware-kanban-actions-bar',
  templateUrl: './kanban-actions-bar.component.html',
  styleUrls: ['./kanban-actions-bar.component.scss']
})
export class KanbanActionsBarComponent implements OnInit {

  constructor() { }

  @Input() public display: boolean = false;
  @Input() public actionsList: ActionI[] = [];
  @Input() public selectedCount: number = 0;
  @Output() public onActionsEventFired: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
  }

  /**
   * On selection of action, fire event with action nam.
   *
   * @param {string} actionType
   * @returns {void}
   */
  public onActionSelected(actionType: KeyValue){
    this.onActionsEventFired.emit(actionType);
  }

}
